import * as React from 'react';
const SvgTouch = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m44.58 88.71-3.87 2.322L2 67.806M56.194 37.226 79.419 23.29 40.71 2 2 23.29M2 23.29l30.968 18.58M79.42 23.29v27.097M40.71 63.935v27.097M2 23.29v44.516M93.461 122l-1.214-1.829-12.828-3.857a9.109 9.109 0 0 1-1.635-.653c-5.139-2.68-9.557-6.953-12.721-11.724L55.36 89.295c-1.67-2.516-2.792-4.732-.179-6.47 2.618-1.732 9.494-.135 11.158 2.381l7.563 11.415-27.227-41.09c-1.67-2.517-.89-5.996 1.722-7.728 2.618-1.732 6.121-1.093 7.79 1.423l17.14 25.867-2.585-3.9c-1.669-2.516-.89-5.995 1.723-7.727 2.618-1.732 6.12-1.093 7.79 1.423l3.847 5.806-1.423-2.143c-1.669-2.517-.89-5.996 1.723-7.728 2.618-1.732 6.121-1.093 7.79 1.423l3.944 5.946-1.515-2.288c-1.669-2.516-.89-5.995 1.723-7.728 2.618-1.732 6.121-1.093 7.79 1.423l8.492 12.813c4.336 6.542 6.915 13.679 8.415 21.387.159.813.198 1.65.13 2.477l-.387 4.975 1.215 1.829"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgTouch;
